export default __webpack_public_path__ + "static/media/windDataSet.8152df68.png";